import { useEffect } from 'react'

interface SeoProps {
  title: string
  description: string
  image?: string
  path?: string
}

export function useSeo({ title, description, image, path }: SeoProps) {
  useEffect(() => {
    const siteName = "Milangela's Soul Garden"
    const fullTitle = title.includes('Soul Garden')
      ? title
      : `${title} — ${siteName}`

    document.title = fullTitle

    const setMetaTag = (name: string, content: string, property?: string) => {
      let element = document.querySelector(
        `meta[${name ? `name="${name}"` : `property="${property}"`}]`,
      )
      if (!element) {
        element = document.createElement('meta')
        if (name) element.setAttribute('name', name)
        if (property) element.setAttribute('property', property)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    setMetaTag('description', description)
    setMetaTag('', fullTitle, 'og:title')
    setMetaTag('', description, 'og:description')

    if (image) setMetaTag('', image, 'og:image')
    if (path)
      setMetaTag('', `https://milangelassoulgarden.com${path}`, 'og:url')
  }, [title, description, image, path])
}
